export type AppEnvironment = "local" | "staging" | "production";

const allowedStagingOrigin = ["app-homolog.feegow.com", "staging", "app-dev"];

/**
 * Identifies the running environment (local, staging, production) based on window.location.origin.
 * Only responsibility is environment detection; consumers decide what to do with it.
 */
export function identifyEnvironment(windowLike: Pick<Window, "location"> = window): AppEnvironment {
  const currentOrigin = windowLike.location.origin;

  if (currentOrigin.includes("localhost")) {
    return "local";
  }

  if (allowedStagingOrigin.some((origin) => currentOrigin.includes(origin))) {
    return "staging";
  }

  return "production";
}

export function isLocalEnv(): boolean {
  return identifyEnvironment() === "local";
}

export function isStagingEnv(): boolean {
  return identifyEnvironment() === "staging";
}

export function isProductionEnv(): boolean {
  return identifyEnvironment() === "production";
}

// =============================================================================
// WebSocket URL Configuration
// =============================================================================

const webSocketUrls: Record<AppEnvironment, string> = {
  local: process.env.VUE_APP_WEBSOCKET_URL || "ws://localhost:8082",
  staging: "wss://ai-assistant-v2.staging.feegow.com",
  production: "wss://ai-assistant-v2.feegow.com",
};

/**
 * Get the WebSocket server URL based on the current environment.
 * - Local: ws://localhost:8081
 * - Staging: wss://ai-assistant-v2.staging.feegow.com
 * - Production: wss://ai-assistant.feegow.com
 */
export function getWebSocketUrl(): string {
  const env = identifyEnvironment();
  return webSocketUrls[env];
}
